import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiZap, FiAlertTriangle, FiSliders } = FiIcons;

export default function GeneratorPanel({
  interval,
  setInterval,
  maxFrames,
  setMaxFrames,
  estimatedFrames,
  status,
  error,
  disabled,
  onGenerate
}) {
  const costly = estimatedFrames > 40;

  return (
    <section className="generator-panel">
      <div className="section-heading">
        <span>02</span>
        <div><h2>Analysis settings</h2><p>Balance precision and request size</p></div>
      </div>
      <div className="setting-grid">
        <label className="field">
          <span><SafeIcon icon={FiSliders} /> Sample every</span>
          <select value={interval} onChange={(e) => setInterval(Number(e.target.value))}>
            <option value="1">1 second · High detail</option>
            <option value="1.5">1.5 seconds · Balanced</option>
            <option value="2">2 seconds · Efficient</option>
            <option value="3">3 seconds · Low cost</option>
          </select>
        </label>
        <label className="field">
          <span>Maximum frames</span>
          <input
            type="number"
            min="5"
            max="80"
            value={maxFrames}
            onChange={(e) => setMaxFrames(Number(e.target.value))}
          />
        </label>
      </div>
      <div className={`estimate ${costly ? 'warning' : ''}`}>
        {costly && <SafeIcon icon={FiAlertTriangle} />}
        <div><strong>~{estimatedFrames || maxFrames} frames maximum</strong><span>{costly ? 'Larger request — may use more credits' : 'Optimized for visual analysis'}</span></div>
      </div>
      <button className="generate-button" disabled={disabled} onClick={onGenerate}>
        <SafeIcon icon={FiZap} />
        {status === 'Idle' || status === 'Complete' ? (status === 'Complete' ? 'Generate Again' : 'Generate Sync Cues') : status}
      </button>
      {error && <div className="error-message" role="alert">{error}</div>}
    </section>
  );
}